import { CARD_GROUP_FORM } from '../form-cardgroup-types';
import { displayLinkedCustCGWidget } from '../../../widgets/linked-cust-cg-widget';
import { displaySelectedValue } from '../../../dropdown';

import { ICardGroupInsertUpdate } from '../../../../models/cardgroup.interface';

/**
 * Function to display individual Card Group information on the
 * edit card group page.
 * 
 * @param {object} data data for the card group
 * 
 * @returns void
 */
export const displayCardGroupInfo = (data: ICardGroupInsertUpdate[]) => {
  const con = document.querySelector('.aafp_customer-container') as HTMLElement;
  const {
    customerId,
    customerName,
    cardGroupName,
    paymentMethod,
    timeoutOverride,
    marginCents,
    hoseId,
    terminalTaxes,
  } = data[0];

  CARD_GROUP_FORM.cgName.value = cardGroupName;
  CARD_GROUP_FORM.cgMarginCents.value = parseFloat(marginCents.toString()).toFixed(6);
  CARD_GROUP_FORM.cgTimeoutOverride.checked = timeoutOverride === '1';
  CARD_GROUP_FORM.cgTerminaltax.checked = terminalTaxes === '1';

  const widgetData = [{
    customerId: customerId,
    customerName: customerName,
    partnerName: ''
  }];

  displayLinkedCustCGWidget(con, widgetData);
  
  displaySelectedValue('.aafp_list-payment', 'payment', paymentMethod.toString());
  displaySelectedValue('.aafp_list-hose', 'hose', hoseId!.toString());
}